const tableColumnsConfig = [
  {
    name: "Name",
    fieldName: "name",
    columnName: "Name",
    isSortable: true,
  },
  {
    name: "Modified",
    fieldName: "dateLastModified",
    columnName: "DateLastModified",
    isSortable: true,
    headerTestId: "playlist-modified-header",
  },
  {
    name: "Created",
    fieldName: "dateCreated",
    columnName: "DateCreated",
    isSortable: true,
  },
  {
    name: "Owner",
    fieldName: "createdBy.group.name",
    columnName: "Owner",
    isSortable: false,
  },
  {
    name: "Size",
    fieldName: "size",
    columnName: "Size",
    isSortable: false,
  },
  {
    name: "Used By",
    fieldName: "campaigns",
    columnName: "Campaigns",
    isSortable: false,
  },
];

export default tableColumnsConfig;
